var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleDynamicBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.06 360.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a3a3a3;\n      }\n\n      .cls-2 {\n        fill: none;\n        opacity: .5;\n        stroke: #a3a3a3;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.59,
    y: 160.13,
    width: 40.13,
    height: 40.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.31,
    y: 166.22,
    width: 90.72,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.31,
    y: 183.96,
    width: 173.16,
    height: 10.22
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.93,
    y: 136.72,
    width: 269.2,
    height: 86.94
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleDynamicBanner);
export default __webpack_public_path__ + "static/media/simple_dynamic_banner.f4ab56018aa6950d6de6096872271059.svg";
export { ForwardRef as ReactComponent };